<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="4">
        <v-text-field
            type="email"
            validate-on-blur
            :rules="mailRules"
            v-model="email"
            class="text-input-black"
            label="e-mail"
            @keyup.enter="reg">
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col cols="4">
        <v-text-field
            :rules="noEmpty"
            v-model="name"
            class="text-input-black"
            label="meno"
            @keyup.enter="reg">
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col cols="4">
        <v-text-field
                :rules="noEmpty"
                v-model="surname"
                class="text-input-black"
                label="priezvisko"
                @keyup.enter="reg">
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col cols="4">
        <v-text-field
            :rules="rules"
            v-model="password"
            class="text-input-black"
            type="password"
            label="heslo"
            @keyup.enter="reg">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="4">
        <v-text-field
            :rules="rules"
            v-model="password2"
            class="text-input-black"
            type="password"
            label="over heslo"
            @keyup.enter="reg">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="4">
        <span class="red--text">{{error}}</span>
      </v-col>
    </v-row>

    <v-row class="justify-center">
      <v-col class="text-center" cols="12">
        <v-btn
          @click="reg()"
          color="accent" 
        >
          zaregistrovať
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
  import store from "../../store/store";
export default {
  name: "Registration",
  data: () => ({
    rules: [
      value => !!value || 'Vyplňte prosím toto pole',
      value => (value && value.length >= 6) || 'Minimálne 6 znakov',
    ],
      mailRules: [
        v => !!v || 'Zadajte e-mail',
        v => (/.+@.+/.test(v)||v.length<3) || 'E-mail je neplatný',
      ],
    noEmpty: [
      value => !!value || 'Vyplňte prosím toto pole',
    ],
    username: '',
    password: '',
    password2: '',
    email: '',
    name: '',
    surname:'',
    error: '',
    success: false,
  }),
  props : ["refForm"],
  methods: {
    alertRegistrationOk() {
      this.success = true;
      setTimeout(() => {
        this.success = false;
      }, 2500)
    },
    reg(){
        if(!this.refForm.validate()) return;
        this.error = '';
        const params = new URLSearchParams();
        params.append('password', this.password);
        params.append('confirm_password', this.password2);
        params.append('email', this.email);
        params.append('name', this.name);
        params.append('surname', this.surname);
        axios({
          method: 'post',
          url: store.state.url.concat('register.php'),
          data: params
        }).then((response) => {
          if(response.data.result == 'ok') {
            this.alertRegistrationOk()
            this.$emit('registerCompleted')
          }
          else{
            this.error = response.data.error;
          }
        });
    }
  }
}
</script>

<style scoped>

</style>